const NumberConversion = (num, remove$) => {
  if (num === '' || num === undefined || num === null) {
    return remove$ ? "0.00" : '$0.00'
  } else {
    let converted_Number = remove$
      ? parseFloat(num).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }).replace("$", '')
      : parseFloat(num).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    return converted_Number
  }
}
export default NumberConversion
